import styled, { css } from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import { Grid } from '../../Grid';

export const GridWithMargins = styled(Grid)`
  && {
    margin-top: ${spacing(4)};
    margin-bottom: ${spacing(4)};

    ${mediaQuery.tabletLandscape`
      margin-top: ${spacing(6)} ;
      margin-bottom: ${spacing(8)};
    `}
  }
`;

type HeadingProps = {
  useColoredHeading?: boolean;
};

export const Heading = styled.h1<HeadingProps>`
  ${fonts.headingLarge}
  ${({ useColoredHeading }) =>
    useColoredHeading &&
    css`
      color: ${colors.core01};
    `};
  margin: 0;
`;

export const Subhead = styled.p`
  ${fonts.paragraphLarge}
  margin: ${spacing(2)} 0 0;

  ${mediaQuery.tabletPortrait`
    margin: ${spacing(1)} 0 0;
  `}
`;

export const PageInfo = styled.ul`
  ${fonts.paragraphSmall}
  margin: ${spacing(3)} 0 0;
  padding: 0;

  > li {
    list-style-type: none;
    display: inline;
  }

  > li:not(:first-child)::before {
    content: ' | ';
  }
`;

export const AuthorName = styled.span`
  color: ${colors.core01};
`;
